// extracted by mini-css-extract-plugin
export default {"container":"richTextViewExamples_container__vmkY9"};